import * as React from 'react';
import { TerminalCommunicationService } from '@fresche/terminal-lib';
import AppHeader from '../app-header/AppHeader';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import './OnError.css';

declare global {
  interface Window { config: any; }
}

export default class OnError extends React.Component<any, any> {
  private terminal: TerminalCommunicationService;

  handleHomeClick(): void {
    this.terminal = new TerminalCommunicationService();
    // Check in config if tenant-id is there, otherwise in the Url...nothing 
    const myParam = window.config && window.config['backend'] && window.config['backend']['tenant-id'] !== '' ? window.config['backend']['tenant-id'] : 'default';
    const additionalHeaders = { 'tenant-id': myParam };
    this.terminal.init(additionalHeaders, {}, window.config);
    this.terminal.gotoLocation('/');
  }

  render(): React.ReactElement {
    let errorTxt = 'An error occured somewhere in the backend';
    const url = new URL(window.location.href);
    const errorParam = url.searchParams.get('error');

    if (errorParam) {
      errorTxt = errorParam;
    }

    const header = <img alt="Card" src='./images/error.png' />;
    const footer = (<span>
      <Button
        label="Home"
        icon="pi pi-home"
        onClick={(e: any): void => {
          e.preventDefault();
          this.handleHomeClick();
        }}
      />
    </span>);
    return (
      <React.Fragment>
        {/* <AppHeader
          screenDef={null}
          formData={null}
        /> */}
        <Card footer={footer} header={header} className="card ui-card-shadow">
          {errorTxt}
        </Card>
      </React.Fragment>
    );
  }
}
